import { FeatureFlags } from '~/utils/feature-flags.enum'

export default async ({ store, redirect, localePath }) => {
  const usioPilotFlag = FeatureFlags.UsioPaymentEnabled

  if (!(usioPilotFlag in store.state.entity.featureFlag)) {
    await store.dispatch('entity/getUsioFlag')
  }

  if (store.state.entity.featureFlag[usioPilotFlag]) {
    return redirect(localePath('/financials'))
  }
}
